import subscribeToConsumerAsset from './Subscribers/subscribeToConsumerAsset';

const connectAssetSubscriptions = middleware => [
    subscribeToConsumerAsset(middleware.consumerInput.asset$, middleware.state.stores.asset, middleware.player),
];

export default connectAssetSubscriptions;
